import React from "react";
import { EmptyState, Flex, Link } from "@jsq/ds/core";
import { useReportError } from "#common/hooks/useReportError";
import { usePaymentBatchDataContext } from "../../Context/context";
import { PaymentBatchWorkflowStepProps } from "../../types";
import { errorStepContainer } from "./styles_vanilla.css";

const ErrorStep: React.FC<PaymentBatchWorkflowStepProps> = () => {
  const { errorMessage } = usePaymentBatchDataContext();

  useReportError(errorMessage);

  return (
    <Flex className={errorStepContainer} alignItems="center" flexGrow={1}>
      <EmptyState
        illustration="document-failure"
        title="Payments batch not created"
        description={errorMessage}
      >
        <Link displayAsButton href="/canopy/treasury/transactions" variant="primary">
          Go to transactions dashboard
        </Link>
      </EmptyState>
    </Flex>
  );
};

export default ErrorStep;
